import {
  FETCH_ALL_LICENSE_GROUPS,
} from '../../mutation-types';

export default {
  [FETCH_ALL_LICENSE_GROUPS](state, licenseGroups) {
    state.all = licenseGroups;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/licenseGroup/mutations.js